import { c as _c } from "react/compiler-runtime";
// «Мои покупки» — товары из доставленных заказов (для повторной покупки): поиск,
// чипы «Выкуплен | Возврат», сортировка, список позиций. Данные — GET
// /buyer/purchases. Раздел объединён с «Мои заказы»: вид показывается во
// вкладке «Завершенные заказы» при включённом тумблере «показать товары»
// (кадр «Профиль-Мои заказы-Завершенные» 3956:117714), поэтому вынесен в
// переиспользуемый `PurchasesView` без обёртки-панели. Тумблер и сортировка —
// общая полоса `FinishedToolbar`: та же стоит над списком заказов, когда
// тумблер выключен.

import { Skeleton } from "@osmix/ui/skeleton";
import { SearchLine16Icon, SortIcon } from "@/components/icons";
import { useState } from "react";
import type { BuyerPurchase } from "@/api";
import { usePurchaseActions, usePurchases } from "@/components/profile/purchase-data";
import { PurchaseRow } from "@/components/profile/purchase-row";
import { CabinetEmpty } from "@/components/profile/return-parts";
import { Chip } from "@/components/ui/chip";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/text-field";
import { cn } from "@/lib/utils";
type Chip = "bought" | "returned";
export type FinishedSort = "new" | "old";

// Полоса над «Завершенными» (макет): тумблер «показать товары» 36×20 r96
// (#FF5E00 во включённом), подпись 16/21; справа — сортировка «Сначала новые |
// Сначала старые».
export function FinishedToolbar(t0) {
  const $ = _c(14);
  const {
    showItems,
    onShowItemsChange,
    sort,
    onSortChange
  } = t0;
  const [sortOpen, setSortOpen] = useState(false);
  let t1;
  if ($[0] !== onShowItemsChange || $[1] !== showItems) {
    t1 = <label className="flex cursor-pointer items-center gap-[10px] text-[16px] leading-[21px] font-medium text-ds-primary"><Switch checked={showItems} onCheckedChange={onShowItemsChange} />показать товары</label>;
    $[0] = onShowItemsChange;
    $[1] = showItems;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PopoverTrigger asChild={true}><button type="button" aria-label={"\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430"} className="grid size-8 place-items-center rounded-[8px] text-[#1F1F1F] outline-none hover:bg-[#1F1F1F]/5 focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40"><SortIcon size={24} /></button></PopoverTrigger>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [["new", "\u0421\u043D\u0430\u0447\u0430\u043B\u0430 \u043D\u043E\u0432\u044B\u0435"], ["old", "\u0421\u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0430\u0440\u044B\u0435"]];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onSortChange || $[6] !== sort) {
    t4 = <PopoverContent align="end" sideOffset={4} className="w-auto rounded-[12px] border-0 p-[3px] shadow-[0_4px_16px_rgba(0,0,0,0.08)]">{(t3 as const).map(t5 => {
        const [value, label] = t5;
        return <button key={value} type="button" onClick={() => {
          onSortChange(value);
          setSortOpen(false);
        }} className={cn("flex h-[39px] w-full items-center rounded-[8px] px-3 text-left text-[14px] whitespace-nowrap text-[#1F1F1F] outline-none hover:bg-[#F5F5F5]", sort === value && "bg-[#F5F5F5]")}>{label}</button>;
      })}</PopoverContent>;
    $[5] = onSortChange;
    $[6] = sort;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== sortOpen || $[9] !== t4) {
    t5 = <Popover open={sortOpen} onOpenChange={setSortOpen}>{t2}{t4}</Popover>;
    $[8] = sortOpen;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t5) {
    t6 = <div className="flex items-center justify-between gap-3">{t1}{t5}</div>;
    $[11] = t1;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
export function PurchasesView(t0) {
  const $ = _c(37);
  const {
    onShowItemsChange,
    sort,
    onSortChange
  } = t0;
  const data = usePurchases();
  const actions = usePurchaseActions();
  const [query, setQuery] = useState("");
  const [chip, setChip] = useState(null);
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== actions || $[1] !== chip || $[2] !== data.data?.items || $[3] !== data.data?.products || $[4] !== data.isPending || $[5] !== onShowItemsChange || $[6] !== onSortChange || $[7] !== query || $[8] !== sort) {
    const q = query.trim().toLowerCase();
    let t5;
    if ($[13] !== chip) {
      t5 = i_0 => !chip || (chip === "bought" ? i_0.status === "delivered" : i_0.status !== "delivered");
      $[13] = chip;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    let t6;
    if ($[15] !== sort) {
      t6 = (a, b) => {
        const d = Date.parse(b.orderCreatedAt) - Date.parse(a.orderCreatedAt);
        return sort === "new" ? d : -d;
      };
      $[15] = sort;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    const items = (data.data?.items ?? []).filter(i => !q || i.name.toLowerCase().includes(q) || i.brand.toLowerCase().includes(q)).filter(t5).sort(t6);
    t1 = "flex min-h-[500px] flex-col gap-4";
    if ($[17] !== onShowItemsChange || $[18] !== onSortChange || $[19] !== sort) {
      t2 = <FinishedToolbar showItems={true} onShowItemsChange={onShowItemsChange} sort={sort} onSortChange={onSortChange} />;
      $[17] = onShowItemsChange;
      $[18] = onSortChange;
      $[19] = sort;
      $[20] = t2;
    } else {
      t2 = $[20];
    }
    let t7;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = e => setQuery(e.target.value);
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    let t8;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <SearchLine16Icon size={16} className="text-ds-primary" />;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    let t9;
    if ($[23] !== query) {
      t9 = <Input value={query} onChange={t7} placeholder={"\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043C\u043E\u0438\u043C \u043F\u043E\u043A\u0443\u043F\u043A\u0430\u043C"} aria-label={"\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043C\u043E\u0438\u043C \u043F\u043E\u043A\u0443\u043F\u043A\u0430\u043C"} start={t8} fieldClassName="max-w-[299px] gap-1.5" />;
      $[23] = query;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    let t10;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = [["bought", "\u0412\u044B\u043A\u0443\u043F\u043B\u0435\u043D"], ["returned", "\u0412\u043E\u0437\u0432\u0440\u0430\u0442"]];
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    let t11;
    if ($[26] !== chip) {
      t11 = (t10 as const).map(t12 => {
        const [value, label] = t12;
        return <Chip key={value} selected={chip === value} onClick={() => setChip(c => c === value ? null : value)} className="h-10 px-4 text-[16px] leading-[21px]">{label}</Chip>;
      });
      $[26] = chip;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    if ($[28] !== t11 || $[29] !== t9) {
      t3 = <div className="flex flex-wrap items-center gap-2.5">{t9}{t11}</div>;
      $[28] = t11;
      $[29] = t9;
      $[30] = t3;
    } else {
      t3 = $[30];
    }
    t4 = data.isPending ? <div className="flex flex-col gap-2.5">{[0, 1, 2].map(_temp)}</div> : items.length === 0 ? <CabinetEmpty title={(data.data?.items ?? []).length ? "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0448\u043B\u043E\u0441\u044C" : "\u041F\u043E\u043A\u0443\u043F\u043E\u043A \u043F\u043E\u043A\u0430 \u043D\u0435\u0442"} hint={(data.data?.items ?? []).length ? "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u0435 \u0437\u0430\u043F\u0440\u043E\u0441 \u0438\u043B\u0438 \u0444\u0438\u043B\u044C\u0442\u0440." : "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0442\u043E\u0432\u0430\u0440\u044B \u0438\u0437 \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u043A\u0430\u0437\u043E\u0432."} /> : <div className="flex flex-col gap-2.5">{items.map(item => <PurchaseRow key={`${item.orderId}-${item.orderLineId}`} item={item} product={data.data?.products.get(item.productId)} busy={actions.busyId === item.orderLineId + item.orderId} onToCart={() => void actions.toCart(item, data.data?.products.get(item.productId))} onReturn={() => void actions.startReturn(item)} onDispute={() => actions.openDispute(item)} onSupport={actions.openSupport} />)}</div>;
    $[0] = actions;
    $[1] = chip;
    $[2] = data.data?.items;
    $[3] = data.data?.products;
    $[4] = data.isPending;
    $[5] = onShowItemsChange;
    $[6] = onSortChange;
    $[7] = query;
    $[8] = sort;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
  }
  let t5;
  if ($[31] !== actions.modals || $[32] !== t1 || $[33] !== t2 || $[34] !== t3 || $[35] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}{actions.modals}</div>;
    $[31] = actions.modals;
    $[32] = t1;
    $[33] = t2;
    $[34] = t3;
    $[35] = t4;
    $[36] = t5;
  } else {
    t5 = $[36];
  }
  return t5;
}
function _temp(i_1) {
  return <Skeleton key={i_1} className="h-[149px] rounded-[20px]" />;
}